import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/app/layouts/admin.vue").then(m => m.default || m)),
  gallery: defineAsyncComponent(() => import("/app/app/layouts/gallery.vue").then(m => m.default || m))
}